import script from "./DetailsPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailsPanel.vue?vue&type=script&setup=true&lang=js"

import "./DetailsPanel.vue?vue&type=style&index=0&id=333eb186&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-333eb186"]])

export default __exports__